import type { IconProps } from './types';

export function Short({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M68 60 Q128 56 188 60 Q188 70 188 80 Q186 118 180 156 Q160 160 140 156 Q134 130 128 104 Q122 130 116 156 Q96 160 76 156 Q70 118 68 80 Q68 70 68 60 Z" />
      <path d="M68 80 Q128 84 188 80" />
    </svg>
  );
}
